import { BottomNav } from '@/components/apex/BottomNav'
import { ApexHome } from '@/pages/ApexHome'
import { ApexShop } from '@/pages/ApexShop'
import { ApexStudio } from '@/pages/ApexStudio'
import { ApexMove } from '@/pages/ApexMove'
import { ApexProfile } from '@/pages/ApexProfile'
import { ApexOnboarding } from '@/pages/ApexOnboarding'
import { Cart } from '@/components/apex/Cart'
import { ProductDetailModal } from '@/components/apex/ProductDetailModal'
import { AchievementUnlock, useAchievementUnlock } from '@/components/apex/AchievementUnlock'
import { QuickActions } from '@/components/apex/QuickActions'
import { MessagingSystem } from '@/components/apex/MessagingSystem'
import { LiveActivity, useLiveActivity } from '@/components/apex/LiveActivity'
import { AdvancedSearch } from '@/components/apex/AdvancedSearch'
import { PerformanceMonitor } from '@/components/apex/PerformanceMonitor'
import { AdminDashboard } from '@/components/apex/AdminDashboard'
import { ContentCurator } from '@/components/apex/ContentCurator'
import { AdvancedOnboarding } from '@/components/apex/AdvancedOnboarding'
import { BusinessIntelligence } from '@/components/apex/BusinessIntelligence'
import { AdvancedAnalytics } from '@/components/apex/AdvancedAnalytics'
import { UserBehaviorTracker } from '@/components/apex/UserBehaviorTracker'
import { ApexProvider, useApexState } from '@/hooks/useApexState'
import { useState, useEffect } from 'react'
import { PredictiveModeling } from '@/components/apex/PredictiveModeling'
import { ReportBuilder } from '@/components/apex/ReportBuilder'
import { AdvancedSecurity } from '@/components/apex/AdvancedSecurity'
import { PaymentProcessing } from '@/components/apex/PaymentProcessing'
import { Leaderboards } from '@/components/apex/Leaderboards'
import { ThemeProvider } from '@/components/theme-provider'
import { ModeToggle } from '@/components/theme-toggle'
import { EmailNotifications } from '@/components/apex/EmailNotifications'
import { PushNotifications } from '@/components/apex/PushNotifications'
import { EventTracking } from '@/components/apex/EventTracking'
import { RealtimeCollaboration } from '@/components/apex/RealtimeCollaboration'

function AppContent() {
  const { state, actions } = useApexState()
  const [showCart, setShowCart] = useState(false)
  const [showMessages, setShowMessages] = useState(false)
  const [showSearch, setShowSearch] = useState(false)
  const [showPerformance, setShowPerformance] = useState(false)
  const [showAdmin, setShowAdmin] = useState(false)
  const [showCurator, setShowCurator] = useState(false)
  const [showAdvancedOnboarding, setShowAdvancedOnboarding] = useState(false)
  const [showBI, setShowBI] = useState(false)
  const [showAdvancedAnalytics, setShowAdvancedAnalytics] = useState(false)
  const [showUserBehavior, setShowUserBehavior] = useState(false)
  const [showPredictiveModeling, setShowPredictiveModeling] = useState(false)
  const [showReportBuilder, setShowReportBuilder] = useState(false)
  const [showAdvancedSecurity, setShowAdvancedSecurity] = useState(false)
  const [showPaymentProcessing, setShowPaymentProcessing] = useState(false)
  const [showLeaderboards, setShowLeaderboards] = useState(false)
  const [showEmailNotifications, setShowEmailNotifications] = useState(false)
  const [showPushNotifications, setShowPushNotifications] = useState(false)
  const [showEventTracking, setShowEventTracking] = useState(false)
  const [showRealtimeCollaboration, setShowRealtimeCollaboration] = useState(false)
  const { achievement, isVisible: showAchievement, showAchievement: triggerAchievement, hideAchievement } = useAchievementUnlock()
  const { isVisible: showLiveActivity, isMinimized, toggle: toggleLiveActivity, hide: hideLiveActivity } = useLiveActivity()

  // Keyboard shortcuts (must be declared before any early returns)
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.shiftKey) {
        switch (event.key) {
          case 'A':
            if (process.env.NODE_ENV === 'development') { event.preventDefault(); setShowAdmin(true) }
            break
          case 'C':
            if (process.env.NODE_ENV === 'development') { event.preventDefault(); setShowCurator(true) }
            break
          case 'O':
            if (process.env.NODE_ENV === 'development') { event.preventDefault(); setShowAdvancedOnboarding(true) }
            break
          case 'B':
            if (process.env.NODE_ENV === 'development') { event.preventDefault(); setShowBI(true) }
            break
          case 'E':
            if (process.env.NODE_ENV === 'development') { event.preventDefault(); setShowAdvancedAnalytics(true) }
            break
          case 'U':
            if (process.env.NODE_ENV === 'development') { event.preventDefault(); setShowUserBehavior(true) }
            break
          case 'P':
            if (process.env.NODE_ENV === 'development') { event.preventDefault(); setShowPredictiveModeling(true) }
            break
          case 'R':
            if (process.env.NODE_ENV === 'development') { event.preventDefault(); setShowReportBuilder(true) }
            break
          case 'S':
            if (process.env.NODE_ENV === 'development') { event.preventDefault(); setShowAdvancedSecurity(true) }
            break
          case 'T':
            if (process.env.NODE_ENV === 'development') { event.preventDefault(); setShowPaymentProcessing(true) }
            break
          case 'L':
            if (process.env.NODE_ENV === 'development') { event.preventDefault(); setShowLeaderboards(true) }
            break
          case 'N':
            if (process.env.NODE_ENV === 'development') { event.preventDefault(); setShowEmailNotifications(true) }
            break
          case 'H':
            if (process.env.NODE_ENV === 'development') { event.preventDefault(); setShowPushNotifications(true) }
            break
          case 'K':
            if (process.env.NODE_ENV === 'development') { event.preventDefault(); setShowEventTracking(true) }
            break
          case 'M':
            if (process.env.NODE_ENV === 'development') { event.preventDefault(); setShowRealtimeCollaboration(true) }
            break
        }
      } else if (event.metaKey || event.ctrlKey) {
        switch (event.key) {
          case 'm': event.preventDefault(); setShowMessages(true); break
          case 'l': event.preventDefault(); toggleLiveActivity(); break
          case 'k': event.preventDefault(); setShowCart(true); break
          case 'f':
          case '/': event.preventDefault(); setShowSearch(true); break
        }
      } else if (event.shiftKey && event.key === 'P') {
        if (process.env.NODE_ENV === 'development') { event.preventDefault(); setShowPerformance(true) }
      } else if (event.key === '/' && !event.ctrlKey && !event.metaKey) {
        const target = event.target as HTMLElement
        if (target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA') {
          event.preventDefault(); setShowSearch(true)
        }
      }
    }
    window.addEventListener('keydown', handleKeyPress)
    return () => window.removeEventListener('keydown', handleKeyPress)
  }, [toggleLiveActivity])
  // Show onboarding if user hasn't completed it
  if (!state.isOnboarded && !showAdvancedOnboarding) {
    return <ApexOnboarding />
  }

  // Show advanced onboarding if triggered
  if (showAdvancedOnboarding) {
    return (
      <AdvancedOnboarding
        isOpen={true}
        onComplete={(profile) => {
          console.log('Advanced onboarding completed:', profile)
          setShowAdvancedOnboarding(false)
        }}
      />
    )
  }

  const renderActivePage = () => {
    switch (state.activeTab) {
      case 'home':
        return <ApexHome />
      case 'shop':
        return <ApexShop />
      case 'studio':
        return <ApexStudio />
      case 'move':
        return <ApexMove />
      case 'profile':
        return <ApexProfile />
      default:
        return <ApexHome />
    }
  }

  const triggerTestAchievement = () => {
    const testAchievement = {
      id: "test-achievement",
      title: "Style Master",
      description: "Completed your first style challenge with flying colors!",
      icon: "🎨",
      tier: "gold" as const,
      points: 500,
      rarity: "rare" as const
    }
    triggerAchievement(testAchievement)
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      {renderActivePage()}

      <BottomNav 
        activeTab={state.activeTab} 
        onTabChange={actions.setActiveTab} 
      />

      {showLiveActivity && (
        <LiveActivity
          isMinimized={isMinimized}
          onToggle={toggleLiveActivity}
        />
      )}

      <QuickActions />

      <Cart 
        isOpen={showCart}
        onClose={() => setShowCart(false)}
      />

      <ProductDetailModal
        isOpen={state.showProductModal}
        onClose={actions.hideProductModal}
        product={state.selectedProduct}
      />

      <MessagingSystem
        isOpen={showMessages}
        onClose={() => setShowMessages(false)}
      />

      <AdvancedSearch
        isOpen={showSearch}
        onClose={() => setShowSearch(false)}
      />

      {process.env.NODE_ENV === 'development' && (
        <PerformanceMonitor
          isOpen={showPerformance}
          onClose={() => setShowPerformance(false)}
        />
      )}

      {process.env.NODE_ENV === 'development' && (
        <AdminDashboard
          isOpen={showAdmin}
          onClose={() => setShowAdmin(false)}
        />
      )}

      <ContentCurator
        isOpen={showCurator}
        onClose={() => setShowCurator(false)}
      />

      {process.env.NODE_ENV === 'development' && (
        <BusinessIntelligence
          isOpen={showBI}
          onClose={() => setShowBI(false)}
        />
      )}

      {process.env.NODE_ENV === 'development' && (
        <AdvancedAnalytics
          isOpen={showAdvancedAnalytics}
          onClose={() => setShowAdvancedAnalytics(false)}
        />
      )}

      {process.env.NODE_ENV === 'development' && (
        <UserBehaviorTracker
          isOpen={showUserBehavior}
          onClose={() => setShowUserBehavior(false)}
        />
      )}

      {process.env.NODE_ENV === 'development' && (
        <PredictiveModeling
          isOpen={showPredictiveModeling}
          onClose={() => setShowPredictiveModeling(false)}
        />
      )}

      {process.env.NODE_ENV === 'development' && (
        <ReportBuilder
          isOpen={showReportBuilder}
          onClose={() => setShowReportBuilder(false)}
        />
      )}

      {process.env.NODE_ENV === 'development' && (
        <AdvancedSecurity
          isOpen={showAdvancedSecurity}
          onClose={() => setShowAdvancedSecurity(false)}
        />
      )}

      {process.env.NODE_ENV === 'development' && (
        <PaymentProcessing
          isOpen={showPaymentProcessing}
          onClose={() => setShowPaymentProcessing(false)}
        />
      )}

      {process.env.NODE_ENV === 'development' && (
        <Leaderboards
          isOpen={showLeaderboards}
          onClose={() => setShowLeaderboards(false)}
        />
      )}

      {process.env.NODE_ENV === 'development' && (
        <EmailNotifications
          isOpen={showEmailNotifications}
          onClose={() => setShowEmailNotifications(false)}
        />
      )}

      {process.env.NODE_ENV === 'development' && (
        <PushNotifications
          isOpen={showPushNotifications}
          onClose={() => setShowPushNotifications(false)}
        />
      )}

      {process.env.NODE_ENV === 'development' && (
        <EventTracking
          isOpen={showEventTracking}
          onClose={() => setShowEventTracking(false)}
        />
      )}

      {process.env.NODE_ENV === 'development' && (
        <RealtimeCollaboration
          isOpen={showRealtimeCollaboration}
          onClose={() => setShowRealtimeCollaboration(false)}
        />
      )}
      <AchievementUnlock
        achievement={achievement}
        isVisible={showAchievement}
        onClose={hideAchievement}
      />

      {process.env.NODE_ENV === 'development' && (
        <div className="fixed top-4 left-4 z-50 flex flex-col gap-2">
          <button
            onClick={triggerTestAchievement}
            className="px-3 py-1 bg-accent text-accent-foreground rounded text-xs"
          >
            Test Achievement
          </button>
          <button
            onClick={() => setShowMessages(true)}
            className="px-3 py-1 bg-primary text-black rounded text-xs"
          >
            Messages (⌘M)
          </button>
          <button
            onClick={() => setShowCart(true)}
            className="px-3 py-1 bg-secondary text-secondary-foreground rounded text-xs"
          >
            Cart (⌘K)
          </button>
          <button
            onClick={toggleLiveActivity}
            className="px-3 py-1 bg-tier-creator text-black rounded text-xs"
          >
            Activity (⌘L)
          </button>
          <button
            onClick={() => setShowSearch(true)}
            className="px-3 py-1 bg-purple-500 text-white rounded text-xs"
          >
            Search (⌘F or /)
          </button>
          <button
            onClick={() => setShowPerformance(true)}
            className="px-3 py-1 bg-orange-500 text-white rounded text-xs"
          >
            Performance (Shift+P)
          </button>
          <button
            onClick={() => setShowAdmin(true)}
            className="px-3 py-1 bg-red-500 text-white rounded text-xs"
          >
            Admin (⌘⇧A)
          </button>
          <button
            onClick={() => setShowCurator(true)}
            className="px-3 py-1 bg-blue-500 text-white rounded text-xs"
          >
            AI Curator (⌘⇧C)
          </button>
          <button
            onClick={() => setShowAdvancedOnboarding(true)}
            className="px-3 py-1 bg-green-500 text-white rounded text-xs"
          >
            Advanced Onboarding (⌘⇧O)
          </button>
          <button
            onClick={() => setShowBI(true)}
            className="px-3 py-1 bg-indigo-500 text-white rounded text-xs"
          >
            Business Intelligence (⌘⇧B)
          </button>
          <button
            onClick={() => setShowAdvancedAnalytics(true)}
            className="px-3 py-1 bg-cyan-500 text-white rounded text-xs"
          >
            Analytics (⌘⇧E)
          </button>
          <button
            onClick={() => setShowUserBehavior(true)}
            className="px-3 py-1 bg-lime-500 text-white rounded text-xs"
          >
            User Behavior (⌘⇧U)
          </button>
          <button
            onClick={() => setShowPredictiveModeling(true)}
            className="px-3 py-1 bg-violet-500 text-white rounded text-xs"
          >
            Predictive Modeling (⌘⇧P)
          </button>
          <button
            onClick={() => setShowReportBuilder(true)}
            className="px-3 py-1 bg-orange-500 text-white rounded text-xs"
          >
            Report Builder (⌘⇧R)
          </button>
          <button
            onClick={() => setShowAdvancedSecurity(true)}
            className="px-3 py-1 bg-red-600 text-white rounded text-xs"
          >
            Advanced Security (⌘⇧S)
          </button>
          <button
            onClick={() => setShowPaymentProcessing(true)}
            className="px-3 py-1 bg-gradient-to-r from-cyan-500 to-magenta-500 text-white rounded text-xs font-semibold shadow-lg"
          >
            Payment Processing (⌘⇧T)
          </button>
          <button
            onClick={() => setShowLeaderboards(true)}
            className="px-3 py-1 bg-gradient-to-r from-magenta-500 to-cyan-500 text-white rounded text-xs font-semibold shadow-lg"
          >
            Leaderboards (⌘⇧L)
          </button>
          <button
            onClick={() => setShowEmailNotifications(true)}
            className="px-3 py-1 bg-gradient-to-r from-cyan-500 to-magenta-500 text-white rounded text-xs font-semibold shadow-lg"
          >
            Email Notifications (⌘⇧N)
          </button>
          <button
            onClick={() => setShowPushNotifications(true)}
            className="px-3 py-1 bg-gradient-to-r from-magenta-500 to-lime-500 text-white rounded text-xs font-semibold shadow-lg"
          >
            Push Notifications (⌘⇧H)
          </button>
          <button
            onClick={() => setShowEventTracking(true)}
            className="px-3 py-1 bg-gradient-to-r from-cyan-500 to-blue-500 text-white rounded text-xs font-semibold shadow-lg"
          >
            Event Tracking (⌘⇧K)
          </button>
          <button
            onClick={() => setShowRealtimeCollaboration(true)}
            className="px-3 py-1 bg-gradient-to-r from-purple-500 to-magenta-500 text-white rounded text-xs font-semibold shadow-lg"
          >
            Real-Time Collab (⌘⇧M)
          </button>
        </div>
      )}

      {/* Theme Toggle - Always visible */}
      <div className="fixed top-4 right-4 z-50">
        <ModeToggle />
      </div>
    </div>
  )
}

function App() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="gameshape-apex-theme">
      <ApexProvider>
        <AppContent />
      </ApexProvider>
    </ThemeProvider>
  )
}
export default App